import { createRoot } from "react-dom/client";
import FooterUI from "./FooterUI";

/**
 * Renders the QPP Footer content.
 */
export default class Footer {
  /**
   * @param {Object} options - An object containing content and config data
   * @param {HTMLElement} options.rootElement - Elem inside which to render
   */
  constructor(options) {
    if ("rootElement" in options) {
      const root = createRoot(options.rootElement);
      root.render(<FooterUI />);
    } else {
      const root = createRoot(options);
      root.render(<FooterUI />);
    }
  }
}
